export interface IMasterDataProductPrice {
  productPriceId: number;
  productId: number;
  productKey: string | null;
  itemName: string | null;
  basePrice: number;
  startDate: string | null;
  endDate: string | null;
  isActive: boolean | null;
  createdAt: string | null;
  updatedAt: string | null;
}

export class MasterDataProductPrice {
  private readonly _productPriceId: number;
  private readonly _productId: number;
  private readonly _productKey: string | null;
  private readonly _itemName: string | null;
  private readonly _basePrice: number;
  private readonly _startDate: string | null;
  private readonly _endDate: string | null;
  private readonly _isActive: boolean | null;
  private readonly _createdAt: string | null;
  private readonly _updatedAt: string | null;

  constructor(props: IMasterDataProductPrice) {
    this._productPriceId = props.productPriceId;
    this._productId = props.productId;
    this._productKey = props.productKey;
    this._itemName = props.itemName;
    this._basePrice = props.basePrice;
    this._startDate = props.startDate;
    this._endDate = props.endDate;
    this._isActive = props.isActive;
    this._createdAt = props.createdAt;
    this._updatedAt = props.updatedAt;
  }

  get productPriceId(): number {
    return this._productPriceId;
  }
  get productId(): number {
    return this._productId;
  }
  get productKey(): string | null {
    return this._productKey;
  }
  get itemName(): string | null {
    return this._itemName;
  }
  get basePrice(): number {
    return this._basePrice;
  }
  get startDate(): string | null {
    return this._startDate;
  }
  get endDate(): string | null {
    return this._endDate;
  }
  get isActive(): boolean | null {
    return this._isActive;
  }
  get createdAt(): string | null {
    return this._createdAt;
  }
  get updatedAt(): string | null {
    return this._updatedAt;
  }

  static from(props: IMasterDataProductPrice): MasterDataProductPrice {
    return new MasterDataProductPrice(props);
  }

  static toJSON(entity: MasterDataProductPrice): IMasterDataProductPrice {
    return {
      productPriceId: entity.productPriceId,
      productId: entity.productId,
      productKey: entity.productKey,
      itemName: entity.itemName,
      basePrice: entity.basePrice,
      startDate: entity.startDate,
      endDate: entity.endDate,
      isActive: entity.isActive,
      createdAt: entity.createdAt,
      updatedAt: entity.updatedAt,
    };
  }
}
